import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Home, Search, Compass } from "lucide-react";

export default function NotFound() {
  const { lang } = useLang();
  const location = useLocation();

  return (
    <div className="max-w-2xl mx-auto px-4 py-20 text-center" data-testid="not-found-page">
      <div className="relative inline-block mb-6">
        <div className="wordmark text-[8rem] sm:text-[10rem] text-primary/15 leading-none select-none">404</div>
        <div className="absolute inset-0 grid place-items-center">
          <Compass size={56} className="text-secondary animate-[spin_10s_linear_infinite]" />
        </div>
      </div>

      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-primary mb-3">
        {lang === "hi" ? "रास्ता भटक गए?" : "Lost your way?"}
      </h1>
      <p className="text-sm sm:text-base text-muted-foreground max-w-md mx-auto leading-relaxed">
        {lang === "hi"
          ? "जिस पेज को आप ढूँढ रहे हैं वो शायद खिसक गया, बिक गया, या कभी बना ही नहीं। कोई बात नहीं — हज़ारों प्रॉपर्टीज़ अब भी आपका इंतज़ार कर रही हैं।"
          : "The page you're looking for may have moved, sold out, or never existed. No worries — thousands of properties are still waiting for you."}
      </p>
      <p className="text-xs text-muted-foreground/70 mt-2 font-mono truncate max-w-md mx-auto">
        {location.pathname}
      </p>

      <div className="flex flex-wrap gap-3 justify-center mt-8">
        <Link to="/">
          <Button className="bg-primary hover:bg-primary/90 rounded-full px-6" data-testid="not-found-home-btn">
            <Home size={14} className="mr-2" />{lang === "hi" ? "होम पर वापस" : "Back Home"}
          </Button>
        </Link>
        <Link to="/browse">
          <Button variant="outline" className="rounded-full px-6 border-2" data-testid="not-found-browse-btn">
            <Search size={14} className="mr-2" />{lang === "hi" ? "प्रॉपर्टी देखें" : "Browse Properties"}
          </Button>
        </Link>
      </div>
    </div>
  );
}
